import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ClientService {

  private clients: any;
  private clientId: string;

  constructor(private httpClient: HttpClient) { }

  getClient(clientId?: string): Observable<any> | any {

    if (this.clients != null) {
      return this.findClient(clientId);
    } else {
      return this.fetchClients().pipe(
        map(p => {
          return this.findClient(clientId);
        })
      );
    }
  }

  setClient(clientId: string): void {
    this.clientId = clientId.toLowerCase();
  }

  private findClient(clientId: string): any {
    if (this.clients != null) {
      return this.clients[clientId || this.clientId];
    }

    return null;
  }

  private fetchClients(): Observable<any> {
    return this.httpClient.get('./assets/clients.json')
    .pipe(
      tap(response => {
        this.clients = response;
      })
    );
  }

}
